// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2sX-P","title":"Header_title__1RiK-","side":"Header_side__3e01s"};